// extracted by mini-css-extract-plugin
export default {"container":"SectionServicePage_container__rha4Z","headerContainer":"SectionServicePage_headerContainer__WcpG4"};